export function createCheckpoint(levelIndex = 0, score = 0) {
  const checkpoint = { levelIndex, score };

  return {
    current: checkpoint,
    previous: checkpoint,
  };
}

export function advanceCheckpoint(checkpoint, nextLevelIndex, score) {
  return {
    previous: checkpoint.current,
    current: {
      levelIndex: nextLevelIndex,
      score,
    },
  };
}

export function getGameOverRestartCheckpoint(currentLevelIndex, checkpoint) {
  const retryLevelIndex = Math.max(0, currentLevelIndex - 1);
  const retryScore = checkpoint.previous.levelIndex === retryLevelIndex
    ? checkpoint.previous.score
    : 0;

  return {
    levelIndex: retryLevelIndex,
    score: retryScore,
  };
}
